import { render, staticRenderFns } from "./Drivetrains.vue?vue&type=template&id=1e35b384"
import script from "./Drivetrains.vue?vue&type=script&lang=js"
export * from "./Drivetrains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports